import Header from "../../header/header";
import "./page.css"
import { Link } from "react-router-dom";
export function Competepage() {
    return (
      <body>
  
      <div id="top">
        <Header />
        <section class="py-5 text-center ">
          <div class="py-lg-5">
            <div class="col-lg-6 col-md-8 mx-auto">
              <h1 class="title display-1" >專題與競賽</h1>
            </div>
          </div>
        </section>
      </div><div class="d-md-flex flex-md-equal w-100  ps-md-3 justify-content-center ">
        <div class="bg-body-tertiary me-md-3 pt-3 px-3 pt-md-3 px-md-5 text-left overflow-hidden col-md-8">
          <div class="row featurette">
            <div >
              <p class="display-5 mt-md-5 " id="invent">專題</p>
              <p class="content mt-md-5 px-md-3">1.	影像辨識及情境感知之音樂推薦平台，2022第三屆高科盃全國商業智慧競賽，第二名，2022/10/30。</p>
              <p class="content mt-md-5 px-md-3">2.	理想記帳，2022第三屆高科盃全國商業智慧競賽，佳作，2022/10/30。</p>
              <p class="content mt-md-5 px-md-3">3.	結合數據分析與推薦技術之客製化委託設計平台，2022第三屆高科盃全國商業智慧競賽，佳作，2022/10/30。</p>
              <p class="content mt-md-5 px-md-3">4.	影像辨識及情境感知之音樂推薦平台，2022年馬來西亞ITEX國際發明展，銀牌，2022/05/26-27。</p>
              <p class="content mt-md-5 px-md-3">5.	基於人工智慧與物聯網技術建構智慧型居家照護系統，2022年法國巴黎國際發明展，銅牌，2022/05/26-27。</p>
              <p class="content mt-md-5 px-md-3">6.	基於影像辨識與食譜推薦之主廚推薦平台，正修科技大學 2022 校園程式作品競賽，創新專業組，特優，2022/06/05。</p>
              <p class="content mt-md-5 px-md-3">7.	基於影像辨識及情境感知之音樂推薦平台，正修科技大學 2022 校園程式作品競賽，創新專業組，優等，2022/06/05。</p>
              <p class="content mt-md-5 px-md-3">8.	肢端黑色素細胞癌檢測，正修科技大學 2022 校園程式作品競賽，創新專業組，佳作，2022/06/05。</p>
              <p class="content mt-md-5 px-md-3">9.	基於影像辨識及情境感知之音樂推薦平台，團隊：漸行薦樂，「2022資訊智慧創新跨域專題競賽」，南臺科技大學資管系舉辦，特優，2022/06/13。</p>
              <p class="content mt-md-5 px-md-3">10.	基於影像辨識之竊盜行為偵測管理平台，團隊：鑒影度形，「2022資訊智慧創新跨域專題競賽」，南臺科技大學資管系舉辦，優等，2022/06/13。</p>
              
              

            </div>

          </div>
          
        </div>
        
      </div>
      <div class="d-md-flex flex-md-equal w-100  ps-md-3 justify-content-center ">
        <div class="bg-body-tertiary me-md-3 pt-3 px-3 pt-md-3 px-md-5 text-left overflow-hidden col-md-8">
          <div class="row featurette">
            <div >
              <p class="display-5 mt-md-5 " id="invent">競賽</p>
              <p class="content mt-md-5 px-md-3">1.	影像辨識及情境感知之音樂推薦平台，2022第三屆高科盃全國商業智慧競賽，第二名，2022/10/30。</p>
              <p class="content mt-md-5 px-md-3">2.	理想記帳，2022第三屆高科盃全國商業智慧競賽，佳作，2022/10/30。</p>
              <p class="content mt-md-5 px-md-3">3.	結合數據分析與推薦技術之客製化委託設計平台，2022第三屆高科盃全國商業智慧競賽，佳作，2022/10/30。</p>
              <p class="content mt-md-5 px-md-3">4.	影像辨識及情境感知之音樂推薦平台，2022年馬來西亞ITEX國際發明展，銀牌，2022/05/26-27。</p>
              <p class="content mt-md-5 px-md-3">5.	基於人工智慧與物聯網技術建構智慧型居家照護系統，2022年法國巴黎國際發明展，銅牌，2022/05/26-27。</p>
              <p class="content mt-md-5 px-md-3">6.	基於影像辨識與食譜推薦之主廚推薦平台，正修科技大學 2022 校園程式作品競賽，創新專業組，特優，2022/06/05。</p>
              <p class="content mt-md-5 px-md-3">7.	基於影像辨識及情境感知之音樂推薦平台，正修科技大學 2022 校園程式作品競賽，創新專業組，優等，2022/06/05。</p>
              <p class="content mt-md-5 px-md-3">8.	肢端黑色素細胞癌檢測，正修科技大學 2022 校園程式作品競賽，創新專業組，佳作，2022/06/05。</p>
              <p class="content mt-md-5 px-md-3">9.	基於影像辨識及情境感知之音樂推薦平台，團隊：漸行薦樂，「2022資訊智慧創新跨域專題競賽」，南臺科技大學資管系舉辦，特優，2022/06/13。</p>
              <p class="content mt-md-5 px-md-3">10.	基於影像辨識之竊盜行為偵測管理平台，團隊：鑒影度形，「2022資訊智慧創新跨域專題競賽」，南臺科技大學資管系舉辦，優等，2022/06/13。</p>
              <p class="content mt-md-5 px-md-3">11.	影像辨識與食譜推薦之主廚推薦平台，正修科技大學資訊管理系110學年度專題製作競賽，佳作（第二名），2022/04/29。</p>
              <p class="content mt-md-5 px-md-3">12.	AIOT智慧型居家照護系統，正修科技大學資訊管理系110學年度專題製作競賽，佳作（第二名），2022/04/29。</p>
              <p class="content mt-md-5 px-md-3">13.	111年度獎勵師生及校友創業計畫，正修科技大學育成中心舉辦，第一名，獲得高雄市青年局40萬元補助，2022/04/21。</p>
              <p class="content mt-md-5 px-md-3">14.	109年度教育部教學實踐績優計畫【錄取率7%】，運用素養導向教育、設計服務流程、新領人才教育模式探討技職大學生物聯網程式設計課程中情緒調整與自我調節學習策略對學業歷程與學習成就之關係 (PBM1090545)，商業及管理類別，2022/03/29。</p>
              <p class="content mt-md-5 px-md-3">15.	智慧型學齡兒童疾病照護推薦平台，2021第32屆馬來西亞ITEX國際發明展，2022-01-20。</p>
              <p class="content mt-md-5 px-md-3">16.	竊車偵測平台，高雄國際發明展，銅牌，2022/01/20。</p>
              <p class="content mt-md-5 px-md-3">17.	科技部111年度，大專校院研究獎勵人才補助。</p>
              <p class="content mt-md-5 px-md-3">18.	An Intelligent Medical-Care System for Children with Techniques of Disease Detection and Clinic Recommendation, ITEX 2021 Brozen Medal, 32nd International Invention, Innovation & Technology Exhibition 2021 Kuala Lumpur, Malaysia, 2021/12/13-14。</p>
              <p class="content mt-md-5 px-md-3">19.	基於深度學習為基礎之英語詞彙學習平台，2021羅馬尼亞 EUROINVENT歐洲盃國際發明展，銅牌，2021/12/19。</p>
              <p class="content mt-md-5 px-md-3">20.	基於影像辨識之竊盜行為偵測管理平台，2021校園程式作品競賽-創新專業組，正修科技大學，優等，2021/12。</p>
              <p class="content mt-md-5 px-md-3">21.	基於人工智慧與物聯網技術建構智慧型居家照護系統，2021校園程式作品競賽-創新專業組，正修科技大學，優等，2021/12。</p>
              <p class="content mt-md-5 px-md-3">22.	結合環境品質及照護服務之個人化旅遊行程推薦平台，2021校園程式作品競賽-創新專業組，正修科技大學，佳作，2021/12。</p>
              <p class="content mt-md-5 px-md-3">23.	基於深度學習技術檢測舟狀骨診斷及預測，2021校園程式作品競賽-創新專業組，正修科技大學，佳作，2021/12。</p>
              <p class="content mt-md-5 px-md-3">24.	基於影像辨識之竊盜行為偵測管理平台，An Intelligent Car Surveillance Management Platform based on Behavior Image Recognition，2021第8屆高雄KIDE國際發明暨設計展，銅牌，2021/12/2-4。</p>
              <p class="content mt-md-5 px-md-3">25.	影像辨識及情境感知音樂推薦平台， 2021全國大專校院智慧創新技跨域整合創作競賽，值得注目獎，教育部，2021/10/17。</p>
              <p class="content mt-md-5 px-md-3">26.	Deep-Learning based English Vocabulary Learning Platform，基於深度學習為基礎之英語詞彙學習平台，2021法國巴黎國際發明展，Silver Medal，2021-11-04。</p>
              <p class="content mt-md-5 px-md-3">27.	Renovation of smart home care system based on artificial intelligence and Internet of Things technology，智慧型居家照護系統，2021法國巴黎國際發明展，Silver Medal，2021-11-04。</p>
              <p class="content mt-md-5 px-md-3">28.	An Intelligent Car Surveillance Management Platform based on Behavior Image Recognition，International Salon of Inventions and New Technologies, 2021烏克蘭國際發明展，Silver Medal，Sevastopol, Russian Federation，2021/9/23-25。</p>
              <p class="content mt-md-5 px-md-3">29.	基於人工智慧技術之食譜推薦平台，2021年第三屆綠點子國際發明暨設計競賽，銀牌，2021/08/19 ~ 2021/08/20</p>
              <p class="content mt-md-5 px-md-3">30.	基於深度學習為基礎之英語詞彙學習平台，2021年第三屆綠點子國際發明暨設計競賽，銅牌，2021/08/19 ~ 2021/08/20。</p>
              
              

            </div>

          </div>

        </div>
        
      </div>
      
        
    
      <div class="aa"></div>
    </body>
  
    );
  }

  